





































import Vue, { PropType } from 'vue';
import { FirestoreDate } from '@/modules/firestore';
// import { formatContactListDate } from '@/modules/calender';
import { calender } from 'mostra';
export default Vue.extend({
  name: 'GChatBuyerListItem',
  props: {
    avatar: {
      type: String as PropType<string>,
      default: '',
    },
    latestMessageText: {
      type: String as PropType<string>,
      default: '',
    },
    latestMessageWithUrl: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    latestMessageWithAttachment: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    company: {
      type: String as PropType<string>,
      default: '',
    },
    name: {
      type: String as PropType<string>,
      default: '',
    },
    date: {
      type: [Object, Date] as PropType<FirestoreDate>,
    },
    unseen: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    unreplied: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  methods: {
    onChatItemClick() {
      this.$emit('click');
    },
  },
  data() {
    return {
      displayDate: calender.formatContactListDate(this.date),
    };
  },
});
